import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';
import PlaceRolesSelect from './PlaceRolesSelect';

import { Form, Input, Button, Modal, InputNumber } from 'antd';
const FormItem = Form.Item;

class ParkinglocationPlacesForm extends Component {

  state = {
    modalVisible: false
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {        
        let position = {
          "type": "Point",
          "coordinates": [
            values.positionLon !== undefined ? values.positionLon : 0.0,
            values.positionLat !== undefined ? values.positionLat : 0.0
          ]
        };
        values.coords = position;
        delete values.positionLat;
        delete values.positionLon;      
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Lokalita" >
          {getFieldDecorator('parkingLocationId', {
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <ParkinglocationSelect onChange={(value) => { this.props.form.setFieldsValue({ parkingLocationId: value }); }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Výchozí role" >
          {getFieldDecorator('actualRoleID', {
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <PlaceRolesSelect onChange={(value) => { this.props.form.setFieldsValue({ actualRoleID: value }); }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Role" >
          {getFieldDecorator('roles', {
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <PlaceRolesSelect mode="multiple" onChange={(value) => { this.props.form.setFieldsValue({ roles: value }); }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Místo" >
          {getFieldDecorator('placeID', {
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber min={1} max={999999} />
          )}
        </FormItem>
        <Form.Item
          {...formItemLayout}
          label="Zeměpisná šířka">
          {getFieldDecorator('positionLat', {
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }],
          })(
            <InputNumber />
          )}
        </Form.Item>
        <Form.Item
          {...formItemLayout}
          label="Zeměpisná výška">
          {getFieldDecorator('positionLon', {
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }],
          })(
            <InputNumber />
          )}
        </Form.Item>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Uložit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={650}
          title="Vytvoření nového parkovacího místa"
          visible={this.state.modalVisible}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          footer={<p></p>}>
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(ParkinglocationPlacesForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/ParkinglocationPlacesForm.js